import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Denver.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Maximizing Denver's Digital Evolution: Our Journey Of Innovation
            </h2>
            <p>
              As the premier mobile app development company in Denver, TekRevol
              shines in native and cross-platform app development, pioneering
              integrations, unique feature customization, and preeminent coding
              standards by experienced developers.
            </p>
            <p>
              We believe that businesses accepting technology-driven
              communication and insight to power economic growth will lead the
              digital era. Many companies in Denver are implementing
              digitalization to raise customer experiences, and TekRevol is here
              to guarantee a flawless transition, securing your success.
            </p>
            <p>
              We authorize all businesses with state-of-the-art, user-friendly
              digital solutions, generating sustained revenue growth as a
              leading force in Denver's mobile app landscape. So, start your app
              journey with us today; connect with our experts to chart your path
              to digital success.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
